module.exports = __webpack_public_path__ + "static/img/5.282aa99.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/4/1/zh/5.png
// module id = Zvjb
// module chunks = 0